import { type ApiGroup, type ApiPermission } from '@Model';
import { Column } from '@synqo/frontend-component-library';
import { GroupsLinks } from './GroupsLinks';

/** Get a column that shows which of the linked groups grant each permission. */
export function getPermissionsColumns(linkedGroups: ApiGroup[]): Column<ApiPermission>[] {
    return [
        {
            name: 'stammgruppe',
            label: 'Stammgruppe',
            renderCell: ({ rowData }) => {
                const grantingGroupIds = linkedGroups
                    .filter((g) => g.permissions.includes(rowData.key))
                    .map((g) => g.id);
                return <GroupsLinks groupIds={grantingGroupIds} groups={linkedGroups} />;
            },
        },
    ];
}
